import {API_STATUS} from '@/utils/constants/commonConstants';

/**
 * Save Draft allowed only for brand-new tiers (no status) or Draft status.
 * Published / In Progress and other non-draft statuses keep Save Draft disabled
 * even when the form is dirty.
 */
export const isTierSaveDraftEnabled = (status) => {
  if (status == null || String(status).trim() === '') {
    return true;
  }
  return String(status).trim().toLowerCase() === API_STATUS.DRAFT.toLowerCase();
};
